"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = render;
var _react = _interopRequireDefault(require("react"));
var _client = require("react-dom/client");
/* eslint react/no-render-return-value: 0 */

/**
 * Render a modal in the page through a temporary placeholder.
 *
 * @param {React.ReactElement} modal UXCore2 Modal.
 * @param {String} market Locale.
 * @param {Object} messages Internationalization data.
 * @param {Function} done Optional completion callback.
 * @returns {ReactDOM} Instance of internationalized modal.
 * @api public
 */
function render(modal, market, messages, done = () => {}) {
  const placeholder = document.createElement('div');
  document.body.appendChild(placeholder);

  // attempts to render the 2200 version of modal
  const modalComponent = typeof modal === 'function' ? modal({
    messages,
    portalElem: placeholder
  }) : /*#__PURE__*/_react.default.cloneElement(modal, {
    messages
  });

  // check to see if 2200 actually rendered
  if (placeholder.children.length) {
    return done();
  }
  const root = (0, _client.createRoot)(placeholder);
  root.render(modalComponent);
  done();
}